/* TCG Stop: wensenlijst en vergelijkingslijst, opgeslagen in de browser van de bezoeker. */
(function () {
  if (window.TCGLists) return;

  var KEYS = { wishlist: 'tcg-wishlist', compare: 'tcg-compare' };
  var LIMITS = { wishlist: 50, compare: 4 };
  var memory = { wishlist: [], compare: [] };

  function read(list) {
    try {
      var raw = window.localStorage.getItem(KEYS[list]);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return memory[list].slice();
    }
  }

  function write(list, items) {
    memory[list] = items.slice();
    try { window.localStorage.setItem(KEYS[list], JSON.stringify(items)); } catch (e) { /* opslag geblokkeerd: alleen in geheugen */ }
    document.dispatchEvent(new CustomEvent('tcg:lists-changed', { detail: { list: list, items: items.slice() } }));
  }

  var api = {
    get: read,
    has: function (list, handle) { return read(list).indexOf(handle) !== -1; },
    remove: function (list, handle) {
      write(list, read(list).filter(function (h) { return h !== handle; }));
    },
    toggle: function (list, handle) {
      var items = read(list);
      var i = items.indexOf(handle);
      if (i !== -1) { items.splice(i, 1); write(list, items); return { added: false, items: items }; }
      if (items.length >= LIMITS[list]) return { added: false, full: true, items: items };
      items.push(handle);
      write(list, items);
      return { added: true, items: items };
    },
    limit: function (list) { return LIMITS[list]; },
    money: function (cents) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return '€' + (cents / 100).toFixed(2).replace('.', ',');
      }
    }
  };
  window.TCGLists = api;

  /* Knoppen op de productpagina */
  function syncButtons() {
    document.querySelectorAll('[data-tcg-list-button]').forEach(function (btn) {
      var list = btn.getAttribute('data-tcg-list-button');
      var on = api.has(list, btn.getAttribute('data-handle'));
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-label]');
      var text = btn.getAttribute(on ? 'data-label-on' : 'data-label-off');
      if (label && label.textContent !== text) label.textContent = text;
    });
    document.querySelectorAll('[data-tcg-list-count]').forEach(function (el) {
      var n = api.get(el.getAttribute('data-tcg-list-count')).length;
      var text = n > 0 ? String(n) : '';
      if (el.textContent !== text) el.textContent = text;
      if (el.hidden !== (n === 0)) el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-tcg-list-button]');
    if (!btn) return;
    event.preventDefault();
    var list = btn.getAttribute('data-tcg-list-button');
    var result = api.toggle(list, btn.getAttribute('data-handle'));
    var status = btn.closest('[data-tcg-actions]') && btn.closest('[data-tcg-actions]').querySelector('[data-tcg-status]');
    if (status) {
      if (result.full) status.textContent = btn.getAttribute('data-full-message');
      else status.textContent = result.added ? btn.getAttribute('data-added-message') : btn.getAttribute('data-removed-message');
      var link = status.parentNode.querySelector('[data-tcg-status-link="' + list + '"]');
      status.parentNode.querySelectorAll('[data-tcg-status-link]').forEach(function (a) { a.hidden = true; });
      if (link && (result.added || result.full)) link.hidden = false;
    }
    syncButtons();
  });

  document.addEventListener('tcg:lists-changed', syncButtons);
  window.addEventListener('storage', syncButtons);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncButtons); else syncButtons();
  /* Horizon vervangt delen van de pagina bij een variantwissel: daarna opnieuw synchroniseren */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; syncButtons(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Wensenlijst- en vergelijkpagina */
  function fetchProduct(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .catch(function () { return null; });
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') node.textContent = attrs[k];
      else if (k === 'class') node.className = attrs[k];
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function image(p, width) {
    var src = p.featured_image;
    if (!src) return el('div', { class: 'tcg-saved__noimg', 'aria-hidden': 'true' });
    if (src.indexOf('//') === 0) src = 'https:' + src;
    var url = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    return el('img', { src: url, alt: p.title, loading: 'lazy', width: String(width), height: String(width) });
  }

  function cartForm(p, label) {
    var variant = (p.variants || []).filter(function (v) { return v.available; })[0];
    if (!variant) return el('span', { class: 'tcg-saved__soldout', text: 'Uitverkocht' });
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var form = el('form', { method: 'post', action: root + 'cart/add', class: 'tcg-saved__form' }, [
      el('input', { type: 'hidden', name: 'id', value: String(variant.id) }),
      el('input', { type: 'hidden', name: 'quantity', value: '1' }),
      el('button', { type: 'submit', class: 'tcg-saved__cart', text: label })
    ]);
    return form;
  }

  function removeButton(list, handle, label) {
    var b = el('button', { type: 'button', class: 'tcg-saved__remove', 'aria-label': label });
    b.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    b.addEventListener('click', function () { api.remove(list, handle); });
    return b;
  }

  function availability(p) {
    var preorder = (p.tags || []).indexOf('pre-order') !== -1;
    if (!p.available) return { text: 'Uitverkocht', cls: 'out' };
    if (preorder) return { text: 'Pre-order', cls: 'pre' };
    return { text: 'Op voorraad', cls: 'in' };
  }

  function renderWishlist(root, products) {
    var grid = el('div', { class: 'tcg-saved__grid' });
    products.forEach(function (p) {
      var a = availability(p);
      grid.appendChild(el('article', { class: 'tcg-saved__card' }, [
        removeButton('wishlist', p.handle, 'Verwijder ' + p.title + ' van je wensenlijst'),
        el('a', { href: p.url, class: 'tcg-saved__media' }, [image(p, 480)]),
        el('div', { class: 'tcg-saved__body' }, [
          el('span', { class: 'tcg-saved__badge tcg-saved__badge--' + a.cls, text: a.text }),
          el('a', { href: p.url, class: 'tcg-saved__title', text: p.title }),
          el('span', { class: 'tcg-saved__price', text: api.money(p.price) }),
          p.available ? cartForm(p, 'In winkelwagen') : null
        ])
      ]));
    });
    root.appendChild(grid);
  }

  function renderCompare(root, products) {
    var rows = [
      ['Prijs', function (p) { return api.money(p.price); }],
      ['Beschikbaarheid', function (p) { return availability(p).text; }],
      ['Categorie', function (p) { return p.type || '–'; }],
      ['Taal', function (p) {
        var t = (p.tags || []).join(' ').toLowerCase();
        if (t.indexOf('japans') !== -1) return 'Japans';
        if (t.indexOf('engels') !== -1) return 'Engels';
        return '–';
      }]
    ];
    rows = rows.filter(function (r) { return products.some(function (p) { return r[1](p) !== '–'; }); });
    var table = el('table', { class: 'tcg-saved__table' });
    var head = el('tr', {}, [el('th', { scope: 'row', class: 'tcg-saved__corner' }, [el('span', { class: 'visually-hidden', text: 'Product' })])]);
    products.forEach(function (p) {
      head.appendChild(el('th', { scope: 'col' }, [
        removeButton('compare', p.handle, 'Verwijder ' + p.title + ' uit de vergelijking'),
        el('a', { href: p.url, class: 'tcg-saved__media' }, [image(p, 320)]),
        el('a', { href: p.url, class: 'tcg-saved__title', text: p.title })
      ]));
    });
    table.appendChild(el('thead', {}, [head]));
    var body = el('tbody');
    rows.forEach(function (r) {
      var tr = el('tr', {}, [el('th', { scope: 'row', text: r[0] })]);
      products.forEach(function (p) { tr.appendChild(el('td', { text: r[1](p) })); });
      body.appendChild(tr);
    });
    var cartRow = el('tr', {}, [el('th', { scope: 'row', text: '' })]);
    products.forEach(function (p) { cartRow.appendChild(el('td', {}, [cartForm(p, 'In winkelwagen')])); });
    body.appendChild(cartRow);
    table.appendChild(body);
    root.appendChild(el('div', { class: 'tcg-saved__scroll' }, [table]));
  }

  function renderSaved(container) {
    var list = container.getAttribute('data-tcg-saved');
    var target = container.querySelector('[data-tcg-saved-items]');
    var empty = container.querySelector('[data-tcg-saved-empty]');
    var handles = api.get(list);
    target.innerHTML = '';
    if (!handles.length) { empty.hidden = false; target.setAttribute('aria-busy', 'false'); return; }
    empty.hidden = true;
    target.setAttribute('aria-busy', 'true');
    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var found = products.filter(Boolean);
      var missing = handles.filter(function (h, i) { return !products[i]; });
      if (missing.length) missing.forEach(function (h) { api.remove(list, h); });
      target.innerHTML = '';
      if (!found.length) { empty.hidden = false; }
      else if (list === 'compare') renderCompare(target, found);
      else renderWishlist(target, found);
      target.setAttribute('aria-busy', 'false');
    });
  }

  function initSaved() {
    document.querySelectorAll('[data-tcg-saved]').forEach(renderSaved);
  }
  document.addEventListener('tcg:lists-changed', function (e) {
    document.querySelectorAll('[data-tcg-saved="' + e.detail.list + '"]').forEach(renderSaved);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSaved); else initSaved();
})();
